<template>
  <li class="product-comments-item" :class="{'product-comments-item--short': isShort, 'product-comments-item--comment-modal': isCommentModal}">
    <CommentCard
      @showAnswers="showAnswers"
      @showAnswerForm="showAnswerForm"
      :id="comment.comment_id"
      :avatar="comment.user_picture"
      :label="comment.label"
      :label-type="comment.label_type"
      :comment="comment.comment"
      :reason-for-purchase="comment.reason_for_purchase"
      :rate="comment.rating"
      :name="!comment.is_manager ? comment.user_name : $t('comment.manager')"
      :date="comment.date"
      :is-answers="comment.answers && !!comment.answers.length"
      :answer-btn="comment.answers && comment.answers.length + ' ' + wordFormatter(comment.answers.length, isUkLanguage ? ['відповідь', 'відповіді', 'відповідей'] : ['ответ', 'ответа', 'ответов'])"
      :hide-btn="comment.comment_id === showingAnswers"
      :is-short="isShort"
      :movedFrom="comment.moved_from"
      :isMoved="comment.is_moved"
      :media="comment.media"
      :is-comment-modal="isCommentModal"
      :endpoint="endpoint"
      :product-id="productId"
      :is-questions="isQuestions"
      :tags="computedTags"
      :is-disabled-actions="isDisabledActions"
    />
    <div class="product-comments-item__answer-form" v-if="comment.comment_id === showingAnswerForm">
      <QuestionsForm
        v-if="isQuestions"
        :type="$constants.QUESTIONS.FORM_TYPE_ANSWER"
        :endpoint="endpoint"
        :parentId="+comment.comment_id"
        :product-id="productId"
        @hideAnswerForm="hideAnswerForm"
        @submitted="closeFormByTimeout"
      />
      <CommentsForm
        v-else
        :type="$constants.COMMENTS.FORM_TYPE_ANSWER"
        :endpoint="endpoint"
        :parentId="+comment.comment_id"
        :product-id="productId"
        @hideAnswerForm="hideAnswerForm"
        @submitted="closeFormByTimeout"
      />
    </div>
    <div class="product-comments-item__answer" v-if="comment.answers">
      <CommentCard
        answer
        v-for="(answer, i) in comment.answers"
        :key="i"
        :answer-key="i"
        :show-all-answers="comment.comment_id === showingAnswers || isCommentModal"
        :avatar="answer.user_picture"
        :date="answer.date"
        :name="!answer.is_manager ? answer.user_name : $t('comment.manager')"
        :comment="answer.comment"
        :is-short="isShort"
        :movedFrom="answer.moved_from"
        :isMoved="answer.is_moved"
        :endpoint="endpoint"
        :product-id="productId"
        :is-questions="isQuestions"
      />
    </div>
    <button
      v-if="!isShort && comment.answers && comment.answers.length > 1 && !(comment.comment_id === showingAnswers) && !isCommentModal"
      class="product-comments-item__btn"
      @click="showAnswers(comment.comment_id)"
    >
      {{ $t('open.comment') }}
    </button>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'
import CommentCard from './CommentCard'
import CommentsForm from './CommentsForm'
import QuestionsForm from '@/components/questions/QuestionsForm.vue'
import { wordFormatter } from '@/mixins/wordFormatter'

export default {
  name: 'CommentItem',
  data () {
    return {
      showingAnswers: null,
      sendAnswerForId: null,
      showingAnswerForm: null
    }
  },
  mixins: [wordFormatter],
  props: {
    isQuestions: {
      type: Boolean,
      default: false
    },
    isDisabledActions: {
      type: Boolean,
      default: false
    },
    productId: {
      type: Number,
      default: null
    },
    comment: {
      type: Object
    },
    isShort: {
      type: Boolean,
      default: false
    },
    isCommentModal: {
      type: Boolean,
      default: false
    },
    endpoint: {
      type: String,
      required: true
    }
  },
  components: {
    CommentsForm,
    CommentCard,
    QuestionsForm
  },
  methods: {
    showAnswerForm (id) {
      this.sendAnswerForId = id
      this.showingAnswerForm = id
    },
    showAnswers (id) {
      this.showingAnswers = id
    },
    hideAnswerForm () {
      this.showingAnswerForm = null
    },
    closeFormByTimeout () {
      setTimeout(this.hideAnswerForm, 2000)
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix', 'isUkLanguage']),
    computedTags () {
      return this.comment.tags ? Object.values(this.comment.tags) : []
    }
  }
}
</script>
<style lang="sass">
.product-reviews-slider
  .all-link
    margin-top: 5px !important
    +mmax($tablet)
      width: 100%
      padding-bottom: 15px
      border-bottom: 1px solid #e7e7e7
      margin-top: 2px !important
  .product-comments-item
    &:last-child
      +mmax($tablet)
        padding-top: 15px !important
        margin-bottom: 0
        border-bottom: none
</style>
<style scoped lang="sass">
.product-comments-item
  border-bottom: 1px solid #e7e7e7

  &--comment-modal
    border-bottom: none

.product-comments-item--short
  &:not(:first-child)
    padding-top: 15px

.product-comments-item__btn
  color: #3e77aa
  font-size: 14px
  background: transparent
  border-color: transparent
  padding: 0
  border-bottom: 1px dashed #3e77aa
  cursor: pointer
  margin: 0 auto 40px
  display: block

  &:hover
    border-color: transparent

.product-comments-item__answer-form,
.product-comments-item__answer
  +mmin($tablet--hor)
    max-width: 700px
    margin-left: 60px

</style>
